import mobileServiceClient from "./mobileServiceClient";

const API = {};

const calls = {
    adminCheck: ["password"],
    adminGetTherapists: ["adminToken"],
    getCompaniesSuperadmin: ["sortType", "sortColumn", "pageNumber"],
    setCompanySuperadmin: ["companyInfo"],
    getCompanyTherapistsSuperadmin: ["companyId", "sortDirection", "sortColumn"],
    getCompanyYTD: ["companyId"],
    disableCompany: ["companyId", "isDisabled"],
    deleteCompany: ["companyId"],
    getInvoicesByBookingIds: ["bookingIds"],
    getMergedInvoicesByClientId: ["clientId"],
    getMergedInvoicesByTherapist: [],
    deleteInvoice: ["invoiceId"],
    getNewslettersFromTherapist: [],
    updateInvoice: ["invoiceId", "image"],
    getClient: ["id"],
    getClientFromCPR: ["CPR"],
    getTherapist: [],
    //quyNH
    get4LastDigitCPR: [],
    getCompany: [],
    getCompanyTherapists: ["sortColumn", "sortDirection"],
    getTherapistsByCompanyId: ["id", "sortColumn", "sortDirection"],
    getOtherTherapist: ["id"],
    getJournal: ["id"],
    getBooking: ["id"],
    getInvoice: ["id"],
    getInvoicesFromTherapist: [],
    updateContactGuid: ["id", "contactGuid"],
    updateProductGuid: ["id", "productGuid"],
    updateInvoiceGuid: ["id", "invoiceGuid"],
    getCvrFromNumber: ["CVR"],
    getTreatment: ["id"],
    getEvent: ["id"],
    getEventDate: ["id"],
    getBookingsFromTherapist: ["from", "to"],
    getJournalsFromTherapist: [],
    getClientsFromTherapist: [],
    getClientsFromTherapistCompany: [],
    getClientsFromTherapistCompanyOnlineBooking: ["therapistId", "CPR"],
    getClientsByEmailFromTherapist: ["email"],
    getClientsFromTherapistNewsletter: [],
    getCustomFieldsFromTherapistIsJournal: [],
    getCustomFieldsFromTherapistIsNotJournal: [],
    getTreatmentsFromTherapist: [],
    getAvailableTreatmentsFromTherapist: [],
    getBookingsFromClient: ["clientId"],
    getJournalsFromClient: ["clientId"],
    getTherapistsFromClient: ["clientId"],
    getCustomFieldsFromJournal: ["journalId"],
    getCustomFieldsFromClientIsNotJournal: ["clientId"],
    getTherapistFromUsername: ["username"],
    getJournalFromBooking: ["bookingId"],
    getOpeningHoursFromTherapist: ["from", "to"],
    getEventsFromTherapist: [],
    getEventDatesFromTherapist: [],
    getEventDateClientsFromTherapist: [],
    clientGetAvailable: ["therapistId", "from", "to", "duration", "pause"],
    clientGetTreatmentsFromTherapist: ["therapistId", "clientId"],
    clientGetTherapistInfo: ["therapistId"],
    clientGetEventsFromTherapist: ["therapistId"],
    clientGetEventDatesFromEvent: ["eventId"],
    clientGetEventDatesFromTherapist: ["therapistId"],
    clientAddEventDateClients: [
        "nameFirst",
        "nameLast",
        "email",
        "phonePrivate",
        "CPR",
        "eventDateIds",
        "course",
        "CPR6Digit",
        "CPRLast4Digit",
        "clientId"
    ],
    clientUnsubscribe: ["clientId"],
    login: ["username", "password"],
    // addClient: ["client"],
    addEventDates: ["eventId", "dates"],
    addNewsletter: ["newsletter"],
    addTherapist: ["therapist"],
    addBooking: ["booking"],
    addLeave: ["booking"],
    getLeavesForDay: ["booking"],
    addJournal: ["journal"],
    addInvoice: ["number", "bookingId", "image", "isMerged", "clientId"],
    updateClientDineroData: ["therapistId", "code", "fromDate", "toDate", "status"],
    addDayOff: ["date"],
    addCustomField: ["customField"],
    addFriend: ["email", "therapist"],
    addRequest: ["email", "id"],
    addTreatment: ["treatment"],
    addCvrNumber: ["CVR"],
    addEvent: ["title", "description", "limit", "min"],
    addOpeningHours: ["from", "to"],
    addPause: ["pause"],
    setNewsletter: ["newsletter"],
    setPassword: ["oldPassword", "newPassword"],
    setClient: ["client"],
    setTherapist: ["therapist"],
    setTherapistAvailable: ["therapistId", "isAvailable"],
    setCompany: ["companyInfo"],
    setBooking: ["booking"],
    setJournal: ["journal"],
    setFieldComment: ["comment"],
    setCustomFields: ["clientId", "customFields"],
    setCvrCounter: ["CVR", "count"],
    setCustomField: ["customField"],
    setCustomFieldsJournal: ["journalId", "customFields"],
    setTreatment: ["treatment"],
    setEvent: ["event"],
    setEventDate: ["eventDate"],
    deleteNewsletter: ["id"],
    deleteRequest: ["therapist", "senderId"],
    deleteFriend: ["email", "therapist"],
    deleteBooking: ["id"],
    deleteCustomField: ["id"],
    deleteTreatment: ["id"],
    deleteClient: ["id"],
    deleteOpeningHours: ["id"],
    deletePause: ["id"],
    deleteDayOff: ["id"],
    deleteEvent: ["id"],
    deleteEventDate: ["id"],
    deleteEventDates: ["ids"],
    deleteEventDateClient: ["id"],
    checkUsername: ["username"],
    register: ["therapistInfo", "companyInfo"],
    registerInvoice: ["customerHandle"],
    resetPassword: ["email"],
    newsletter: ["subject", "message"],
    newsletterCustom: ["subject", "message", "clientIds"],
    SMS: ["number", "message"],
    invoiceMail: ["to", "subject", "message", "invoice", "filename"],
    clientAddBooking: ["booking"],
    getVismaConnectUrl: [],
    disconnectDinero: [],
    syncDineroData: [],
    getTherapistAzureContainer: ["therapistId"],
    getAzureStorageSASToken: ["containerName"],
    setClientProfileImage: ["profileImageName", "clientId"],
    setJournalImage: ["imagesName", "clientId", "journalId"],
    incrementStorageUsedByTherapistInBytes: ["therapistId", "bytesUsed"],
    decrementStorageUsedByTherapistInBytes: ["therapistId", "bytesFree"],
    setGoogleUploadForClientProfile: ["profileImageName", "clientId"],
    setGoogleUploadForJournalImage: ["imagesName", "clientId", "journalId"],
    getSASTokenForVideoGuide: [],
    addClientFormFields: ["fieldName", "fieldType", "isRequired"],
    updateClientFormFields: ["id", "fieldName", "fieldType", "isRequired"],
    getAllClientFormFields: [],
    addClient: ["client", "clientFormFieldsIds", "therapistId"],
    clientRegister: ["client", "therapistId"],
    clientGetAllClientFormFieldsByTherapistId: ["therapistId"],
    clientUpdate: ["client", "therapistId"],
    getClientByIdForInformationForm: ["id"],
    clientGetData: ["id", "therapistId"],
    deleteClientFormFields: ["id"],
    getClientData: ["id"]
};

const onTimeout = () => {
    localStorage.setItem("token", "");
    localStorage.setItem("adminToken", "");
    window.location.replace("/");
};

let timeout = null;

Object.keys(calls).forEach(action => {
    const args = calls[action];
    API[action] = (...params) => {
        const token = localStorage.getItem("token");
        const adminToken = localStorage.getItem("adminToken");
        const body = {
            token: token ? token : adminToken,
            action: action
        };
        args.forEach((arg, i) => (body[arg] = [...params][i]));
        return new Promise((resolve, reject) => {
            mobileServiceClient
                .invokeApi("HandsOnBookingAPI", {
                    body: body,
                    method: "post",
                    headers: { "content-type": "application/json" }
                })
                .then(
                    data => {
                        if (data.result.adminToken) {
                            localStorage.setItem("adminToken", data.result.adminToken);
                            localStorage.setItem("token", "");
                        }
                        if (data.result.token) {
                            localStorage.setItem("token", data.result.token);
                            localStorage.setItem("adminToken", "");
                        }

                        window.clearTimeout(timeout);
                        if (data.result.expiresIn) timeout = window.setTimeout(onTimeout, data.result.expiresIn * 1000);
                        if (data?.result?.url) resolve(data.result.url);
                        if (data?.result?.status) resolve(data?.result);
                        if (data.result.total) {
                            resolve(data.result);
                        } else {
                            resolve(data.result.data);
                        }
                    },
                    err => {
                        if (["token expired", "jwt must be provided", "jwt malformed"].includes(err.request.response))
                            onTimeout();
                        reject(err.request.response);
                    }
                );
        });
    };
});

export default API;
